module.exports = __webpack_public_path__ + "img/england.b06fa614.png";